import React from 'react'

import PropTypes from 'prop-types'

const ArrowLeft = ({ fill, className, style, width, height }) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox='0 0 24 24'
    fill='none'
    style={style}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z' fill={fill} />
  </svg>
)

ArrowLeft.defaultProps = {
  fill: '#000000',
  className: '',
  style: {},
  width: '24',
  height: '24',
}

ArrowLeft.propTypes = {
  fill: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  width: PropTypes.string,
  height: PropTypes.string,
}

export default ArrowLeft
